/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag">
      <div :style="{ 'cursor-drag': draggingCard === true }" class="vx-row">
        <div class="vx-col w-full">
          <!-- Part A -->
          <vx-card class="mb-base flex flex-col">
            <h3 class="mb-4 pb-4 main-bottom-border flex w-full">Data Flow</h3>

            <div class="flex flex-col items-center w-full">
              <img src="https://ip-learn.b-cdn.net/simulations/secure-data-flow/graphic.png" width="1000" alt="Graphic" />

              <div class="grid grid-cols-4 mt-6" style="column-gap: 90px">
                <div class="flex flex-col gap-3 items-center justify-start" style="width: 178px">
                  <h4>End Client</h4>
                </div>

                <div class="flex flex-col gap-3 items-center justify-center" style="width: 178px">
                  <h4>API Gateway</h4>
                  <v-select
                    class="w-full"
                    :style="getSelectStyle(partA[0])"
                    placeholder="Select..."
                    :options="partAOptions"
                    v-model="partA[0].value"
                  />
                </div>

                <div class="flex flex-col gap-3 items-center justify-center" style="width: 178px">
                  <h4>Database Storage</h4>
                  <v-select
                    class="w-full"
                    :style="getSelectStyle(partA[1])"
                    placeholder="Select..."
                    :options="partAOptions"
                    v-model="partA[1].value"
                  />
                </div>

                <div class="flex flex-col gap-3 items-center justify-center" style="width: 178px">
                  <h4>AI Model Storage</h4>
                  <v-select
                    class="w-full"
                    :style="getSelectStyle(partA[2])"
                    placeholder="Select..."
                    :options="partAOptions"
                    v-model="partA[2].value"
                  />
                </div>
              </div>
            </div>
          </vx-card>

          <!-- Part B -->
          <vx-card class="mb-base">
            <h3 class="mb-4 pb-4 main-bottom-border">Data Protection Techniques</h3>

            <table class="w-full border-collapse">
              <thead>
                <tr>
                  <th class="text-left border-b text-lg">Technique</th>
                  <th class="text-left border-b text-lg">Original Data</th>
                  <th class="text-left border-b text-lg">Modified Data</th>
                </tr>
              </thead>

              <tbody>
                <!-- Row 1 -->
                <tr>
                  <td class="p-3 border-b w-1/4">
                    <v-select
                      class="w-full"
                      :style="getSelectStyle(partB[0])"
                      placeholder="Select..."
                      :options="partBOptions"
                      v-model="partB[0].value"
                    />
                  </td>
                  <td class="p-3 border-b">{name:"john doe", patient_id:"10000", dob:"1980-Jan-05"}</td>
                  <td class="p-3 border-b">{patient_id:"10000", dob:"1980-Jan-05"}</td>
                </tr>

                <!-- Row 2 -->
                <tr>
                  <td class="p-3 border-b">
                    <v-select
                      class="w-full"
                      :style="getSelectStyle(partB[1])"
                      placeholder="Select..."
                      :options="partBOptions"
                      v-model="partB[1].value"
                    />
                  </td>
                  <td class="p-3 border-b">{pin:"999-99-9999", name:"john doe"}</td>
                  <td class="p-3 border-b">{pin:"999-99-9999", name:"john doe", sensitivity:"SECRET"}</td>
                </tr>

                <!-- Row 3 -->
                <tr>
                  <td class="p-3 border-b">
                    <v-select
                      class="w-full"
                      :style="getSelectStyle(partB[2])"
                      placeholder="Select..."
                      :options="partBOptions"
                      v-model="partB[2].value"
                    />
                  </td>
                  <td class="p-3 border-b">{card_number:"1111222233334444", name:"john doe", user_id:"1"}</td>
                  <td class="p-3 border-b">{card_number:"0x0193628825", name:"john doe", user_id:"1"}</td>
                </tr>

                <!-- Row 4 -->
                <tr>
                  <td class="p-3 border-b">
                    <v-select
                      class="w-full"
                      :style="getSelectStyle(partB[3])"
                      placeholder="Select..."
                      :options="partBOptions"
                      v-model="partB[3].value"
                    />
                  </td>
                  <td class="p-3 border-b">{pin:"999-99-9999", name:"john doe"}</td>
                  <td class="p-3 border-b">{pin:"999-99-XXXX", name:"john doe"}</td>
                </tr>

                <!-- Row 5 -->
                <tr>
                  <td class="p-3">
                    <v-select
                      class="w-full"
                      :style="getSelectStyle(partB[4])"
                      placeholder="Select..."
                      :options="partBOptions"
                      v-model="partB[4].value"
                    />
                  </td>
                  <td class="p-3">{ip_addr:"1.2.3.4", cookie:"aK3idkd==", name:"John Doe", uid:"1111"}</td>
                  <td class="p-3">{cookie:"aK3idkd==", uid:"1111"}</td>
                </tr>
              </tbody>
            </table>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      partAOptions: ['TLS 1.2', 'SHA-2 512', 'HMAC_SHA512', 'ECDH', 'CAMELLIA', 'AES-512', 'Ellipctical Curve', 'RSA-2048'],
      partBOptions: ['Anonymization', 'Tokenization', 'Masking', 'De-identification', 'Classification'],

      partA: [
        {
          value: null,
          answer: 'TLS 1.2',
          correct: null,
        },
        {
          value: null,
          answer: 'CAMELLIA',
          correct: null,
        },
        {
          value: null,
          answer: 'RSA-2048',
          correct: null,
        },
      ],

      partB: [
        {
          value: null,
          answer: 'De-identification',
          correct: null,
        },
        {
          value: null,
          answer: 'Classification',
          correct: null,
        },
        {
          value: null,
          answer: 'Tokenization',
          correct: null,
        },
        {
          value: null,
          answer: 'Masking',
          correct: null,
        },
        {
          value: null,
          answer: 'Anonymization',
          correct: null,
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.partA.forEach((item) => {
        if (item.value === item.answer) {
          item.correct = true;
          totalScore++;
        } else {
          item.correct = false;
        }
      });

      this.partB.forEach((item) => {
        if (item.value === item.answer) {
          item.correct = true;
          totalScore++;
        } else {
          item.correct = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
    getSelectStyle(item) {
      if (item.correct === true) {
        return {
          border: '1px solid #28C76F',
          borderRadius: '4px',
        };
      }

      if (item.correct === false) {
        return {
          border: '1px solid #EA5455',
          borderRadius: '4px',
        };
      }

      return {};
    },
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
